import { useLayoutEffect, useState } from 'react';
import type { RefObject } from 'react';

const CARDS_SELECTOR = '[data-scope-container="true"]';
const CARDS_RIGHT_GUTTER_PX = 8;

const measureOverflow = (content: HTMLElement): number => {
    const cards = Array.from(content.querySelectorAll<HTMLElement>(CARDS_SELECTOR));
    if (!cards.length) {
        return 0;
    }

    const cardsRight = Math.max(...cards.map((card) => card.getBoundingClientRect().right));
    const contentRight = content.getBoundingClientRect().right;

    return Math.max(0, Math.ceil(cardsRight + CARDS_RIGHT_GUTTER_PX - contentRight));
};

export const useCardsOverflow = (contentRef: RefObject<HTMLElement>, isActive: boolean): number => {
    const [overflow, setOverflow] = useState(0);

    useLayoutEffect(() => {
        const content = contentRef.current;
        if (!isActive || !content) {
            setOverflow(0);
            return undefined;
        }

        const measure = () => setOverflow(measureOverflow(content));
        measure();

        const resizeObserver = new ResizeObserver(measure);
        resizeObserver.observe(content);
        window.addEventListener('resize', measure);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', measure);
        };
    }, [contentRef, isActive]);

    return overflow;
};
